import { trigger, animate, style, group, animateChild, query, stagger, transition } from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
    transition('* <=> *', [
        query(':enter, :leave', style({ position: 'absolute', width: '100%' })
            , { optional: true }),
        query('.widget', style({ opacity: 0 }), { optional: true }),
        group([  // block executes in parallel
            query(':enter', [
                style({ transform: 'translateY(-20px)', opacity: 0 }),
                animate('0.2s ease-in-out', style({ transform: 'translateY(0px)', opacity: 1 }))
            ], { optional: true }),
            query(':leave', [
                style({ transform: 'translateY(0px)', opacity: 1 }),
                animate('0.2s ease-in-out', style({ transform: 'translateY(-20px)', opacity: 0 }))
            ], { optional: true }),
        ]),
        query(':enter .widget', stagger(200, [
            animate('.4s ease-in-out',
                style({ opacity: 1 })),
        ]), { optional: true })
    ])
])
